// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "contact-centre-reporting" + "." + "3093c3f0" + ".css";
};